export default __webpack_public_path__ + "static/media/Roboto-Regular.30b57652.eot";